import { CloseButton } from "@/components/CloseButton/CloseButton";
import s from "./style.module.scss";
import { UIButton } from "@/components/UIButton/UIButton";
import {
  currentOrderAtom,
  doneOrderAction,
} from "@/core/reatom/state/orders/orders";
import { useAction, useAtom } from "@reatom/npm-react";
import { useState } from "react";
import { Radio } from "@vkontakte/vkui";
import {
  createFeedbackAction,
  feedbackAtom,
} from "@/core/reatom/state/feedback/feedback";
import dayjs from "dayjs";

interface FeedbackProps {
  closeModal: () => void;
  isArbitrage: boolean;
}

export const Feedback = ({ closeModal, isArbitrage }: FeedbackProps) => {
  const [currentOrder] = useAtom(currentOrderAtom);
  const [checkbox, setCheckbox] = useState<"positive" | "negative">("positive");
  const [value, setValue] = useState("");
  const handleFeedback = useAction(createFeedbackAction);
  const [feedback] = useAtom(feedbackAtom);
  const userFeedback = feedback?.items.find(
    (item) => item?.author.id === currentOrder?.author.id
  );
  const handleDoneOrder = useAction(doneOrderAction);

  return (
    <div className={s.wrapper}>
      <div className={s.line}></div>
      <CloseButton onClose={closeModal} />
      <p className={s.title}>
        {!userFeedback ? "Завершение сотрудничества" : "Ваш отзыв по заказу"}
      </p>
      {!isArbitrage && (
        <p className={s.subTitle}>
          {!userFeedback
            ? "Пожалуйста, оставьте отзыв о сотрудничестве и подтвердите закрытие заказа с выплатой всей суммы исполнителю."
            : "Положительный отзыв"}
        </p>
      )}
      {!userFeedback && (
        <div className={s.radioContainer}>
          <Radio
            className={s.radio}
            name="radio"
            value="positive"
            checked={checkbox === "positive"}
            onChange={() => setCheckbox("positive")}
          >
            <span className={s.labelText}>Положительный</span>
          </Radio>
          <Radio
            className={s.radio}
            name="radio"
            value="negative"
            checked={checkbox === "negative"}
            onChange={() => setCheckbox("negative")}
          >
            <span className={s.labelText}>Отрицательный</span>
          </Radio>
        </div>
      )}

      <div className={s.inputContainer}>
        {!userFeedback && <label className={s.inputLabel}>Отзыв</label>}
        <textarea
          className={s.input}
          placeholder="Напишите здесь отзыв об услуге и исполнителе"
          disabled={!!userFeedback?.text}
          value={userFeedback?.text ?? value}
          onChange={(e) => (userFeedback ? null : setValue(e.target.value))}
        />
        <p className={s.help}>
          {userFeedback
            ? dayjs(userFeedback?.created).format("DD.MM.YYYY в HH:mm")
            : "Не более 500 символов"}
        </p>
      </div>
      <div className={s.buttons}>
        <UIButton
          fontType="primary-2"
          className={s.button}
          onClick={
            userFeedback
              ? () => closeModal()
              : () => {
                  if (currentOrder?.id && value.trim()) {
                    if (isArbitrage) {
                      handleFeedback({
                        oid: currentOrder?.id,
                        rating: checkbox,
                        text: value,
                      }).then(() => {
                        closeModal();
                      });
                    } else {
                      handleDoneOrder(currentOrder?.id).then(() => {
                        handleFeedback({
                          oid: currentOrder?.id,
                          rating: checkbox,
                          text: value,
                        });
                        closeModal();
                      });
                    }
                  }
                }

            // handleFeedback({
            //   oid: currentOrder?.id,
            //   rating: checkbox,
            //   text: value,
            // }).then(() => {
            //   if (!isArbitrage) {
            //     handleDoneOrder(currentOrder?.id);
            //   }
            // })
          }
        >
          {userFeedback ? "Закрыть" : "Оставить отзыв"}
        </UIButton>
      </div>
      {!userFeedback && !isArbitrage && (
        <p className={s.description}>
          Нажимая кнопку «Оставить отзыв», вы подтверждаете отсутствие претензий
          к выполненной работе и даете согласие на выплату исполнителю ранее
          зарезервированной суммы.
        </p>
      )}
    </div>
  );
};
